export default {
  buyersMortgageStatus: 'MORTGAGE',
  luovutusilmoitus: {
    kayttotarkoitus: 'AR',
    sukulaisluovutus: false,
    rantatontti: false,
    rakennustiedot: 'RL',
    kaavatiedot: 'AK',
  },

  realtorBankAccount: {
    name: 'string',
    IBAN: 'string',
    BIC: 'string',
  },

  luovutettavatOsuudet: [
    {
      osuus: 'string',
      sellerSocialSecurityNumbers: [
        'string',
      ],
    },
  ],

  panttikirjojenKoodit: [],

  attachments: [],

  initiatorContactInfo: {
    email: 'string',
    phoneNumber: 'string',
    firstName: 'string',
    lastName: 'string',
  },

  luovutuskirjanTyyppi: 'KA',

  suostujat: [
    {
      person: {
        firstName: 'string',
        lastName: 'string',
        socialSecurityNumber: 'string',
        email: 'string',
      },
      suostujanTyyppi: 'LE',
      sellerSocialSecurityNumber: 'string',
    },
  ],

  sopimussakkoPurkamisestaJosKauppahintaaEiMaksetaErapaivana: {
    amountInCents: 0,
  },

  luovutuksenEhdot: [
    {
      title: 'string',
      description: 'string',
    },
  ],

  luovutuksenKohde: 'KK',

  sellers: [
    {
      person: {
        firstName: 'string',
        lastName: 'string',
        socialSecurityNumber: 'string',
        email: 'string',
      },
      bankBusinessId: 'string',
      realtorPayment: {
        amountInCents: 0,
        referenceNumber: 'string',
        message: 'string',
      },
      roles: [
        'LUONNOKSEN_VASTAANOTTAJA',
      ],
    },
  ],

  kauppahinta: {
    amountInCents: 0,
  },

  initiatorPersonId: 'string',

  buyers: [
    {
      person: {
        firstName: 'string',
        lastName: 'string',
        socialSecurityNumber: 'string',
        email: 'string',
      },
      osuus: 'string',
      bankBusinessId: 'string',
      kenenLukuunLainhuutoaHaetaan: 'OL',
    },
  ],

  tradeInitiatedTimestamp: '',
  initiatorTradeReferenceId: '',
  kiinteistotunnus: '',
  laitostunnus: '',
  eiSiirrettavatPanttikirjojenKoodit: [],
};
